import React from "react";

import Image from "2g-image";
import { PlaceholderText } from "2g-placeholder";

import { PATHS } from "b2b/constants";

function Detail() {
  return (
    <div className="b2b-ProvozniInformaceDetail b2b-ProvozniInformaceDetail--placeholder">
      <div>
        <Image src={PATHS.IMAGES.noImage()} />
      </div>
      <PlaceholderText>
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Vivamus
        porttitor turpis ac leo. Aliquam erat volutpat. Suspendisse sagittis
        ultrices augue. Cras elementum. Pellentesque pretium lectus id turpis.
        Mauris dolor felis, sagittis at, luctus sed, aliquam non, tellus.
        Aliquam in lorem sit amet leo accumsan lacinia. Fusce tellus odio,
        dapibus id fermentum quis, suscipit id erat. Aliquam erat volutpat.
        Integer tempor. Vivamus luctus egestas leo. Fusce tellus. Aenean vel
        massa quis mauris vehicula lacinia. Phasellus et lorem id felis nonummy
        placerat. Morbi leo mi, nonummy eget tristique non, rhoncus non leo.
        Etiam commodo dui eget wisi. Neque porro quisquam est, qui dolorem ipsum
        quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam
        eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
        voluptatem. Cum sociis natoque penatibus et magnis dis parturient
        montes, nascetur ridiculus mus. Sed elit dui, pellentesque a, faucibus
        vel, interdum nec, diam. Phasellus faucibus molestie nisl. Mauris dictum
        facilisis augue. Proin in tellus sit amet nibh dignissim sagittis.
        Pellentesque arcu. Suspendisse nisl. Nullam feugiat, turpis at pulvinar
        vulputate, erat libero tristique tellus, nec bibendum odio risus sit
        amet ante. Integer in sapien. Suspendisse nisl. Praesent dapibus. Cras
        pede libero, dapibus nec, pretium sit amet, tempor quis. Nam quis nulla.
        Mauris dolor felis, sagittis at, luctus sed, aliquam non, tellus. Fusce
        aliquam vestibulum ipsum. Suspendisse sagittis ultrices augue. Fusce
        tellus. Fusce aliquam vestibulum ipsum. Quisque porta. Phasellus et
        lorem id felis nonummy placerat. Aenean vel massa quis mauris vehicula
        lacinia. Nam quis nulla. Integer lacinia. Mauris metus. Praesent id
        justo in neque elementum ultrices. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        Aliquam erat volutpat. Cum sociis natoque penatibus et magnis dis
        parturient montes, nascetur ridiculus mus. Maecenas fermentum, sem in
        pharetra pellentesque, velit turpis volutpat ante, in pharetra metus
        odio a lectus. Morbi imperdiet, mauris ac auctor dictum, nisl ligula
        egestas nulla, et sollicitudin sem purus in lacus. Morbi leo mi, nonummy
        eget tristique non, rhoncus non leo. Excepteur sint occaecat cupidatat
        non proident, sunt in culpa qui officia deserunt mollit anim id est
        laborum.
      </PlaceholderText>
    </div>
  );
}

export default React.memo(Detail);
